export type APIErrorData = {
  status: number;
  statusCode: number;
  reason: string;
  error: string;
  extraData?: Record<string, string | number>;
  message: string;
  retry?: boolean;
  contentRejected?: boolean;
  code?: string;
  requiredPermissions?: string[];
};

export default class APIError extends Error {
  status: number;
  statusCode: number;
  reason: string;
  error: string;
  extraData?: Record<string, string | number>;
  retry?: boolean;
  contentRejected?: boolean;
  code?: string;
  requiredPermissions?: string[];

  constructor({
    status,
    statusCode,
    reason,
    error,
    extraData,
    message,
    retry,
    contentRejected,
    code,
    requiredPermissions,
  }: APIErrorData) {
    super(message);
    this.status = status;
    this.statusCode = statusCode;
    this.reason = reason;
    this.error = error;
    this.extraData = extraData;
    this.retry = retry;
    this.contentRejected = contentRejected;
    this.code = code;
    this.requiredPermissions = requiredPermissions;
  }
}
